import React from 'react';
import { View, Text, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { formatViews } from '../../utils/video';
import { VideoDurationBadge } from './VideoDurationBadge';

type VideoCardProps = {
  thumbnailUrl: string;
  title: string;
  channelName: string;
  channelAvatar?: string;
  likeCount: number;
  createdAt: string;
  duration: string; // e.g., "12:34"
  videoUrl?: string;
  videoType?: 'native' | 'youtube';
  onPress?: () => void;
};

const VideoCard: React.FC<VideoCardProps> = ({
  thumbnailUrl,
  title,
  channelName,
  channelAvatar,
  likeCount,
  createdAt,
  duration,
  videoUrl,
  videoType,
  onPress,
}) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <View style={styles.thumbnailContainer}>
        <Image source={{ uri: thumbnailUrl }} style={styles.thumbnail} />
        
        <VideoDurationBadge 
          initialDuration={duration} 
          videoUrl={videoUrl} 
          videoType={videoType} 
        />
      </View>
      <View style={styles.infoContainer}>
        {channelAvatar ? (
          <Image source={{ uri: channelAvatar }} style={styles.channelAvatar} />
        ) : (
          <View style={[styles.channelAvatar, { backgroundColor: '#333' }]} />
        )}
        <View style={styles.textContainer}>
          <Text style={styles.title} numberOfLines={2}>
            {title}
          </Text>
          <Text style={styles.channelInfo}>
            {channelName}
          </Text>
          <Text style={styles.metaInfo}>
            {formatViews(likeCount)} いいね · {createdAt}
          </Text>
        </View>
        <TouchableOpacity style={styles.menuIcon}>
          <Ionicons name="ellipsis-vertical" size={16} color="#fff" />
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginBottom: 20,
  },
  thumbnailContainer: {
    width: '100%',
    aspectRatio: 16 / 9,
    position: 'relative',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
  infoContainer: {
    flexDirection: 'row',
    marginTop: 12,
    paddingHorizontal: 8,
  },
  channelAvatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    marginRight: 12,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  channelInfo: {
    color: '#aaa',
    fontSize: 14,
  },
  metaInfo: {
    color: '#aaa',
    fontSize: 14,
  },
  menuIcon: {
    paddingLeft: 10,
  },
});

export default VideoCard;
